var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_158)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_191_158)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.2381 7.29875C16.1769 7.29 16.1156 7.29 16.0544 7.29875C14.6981 7.255 13.6219 6.14375 13.6219 4.77875C13.6219 3.3875 14.7506 2.25 16.1506 2.25C17.5419 2.25 18.6794 3.37875 18.6794 4.77875C18.6706 6.14375 17.5944 7.255 16.2381 7.29875Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0909 13.3638C18.1109 14.0201 16.7371 14.2651 15.4684 14.0988C15.8009 13.3813 15.9759 12.5851 15.9846 11.7451C15.9846 10.8701 15.7921 10.0388 15.4246 9.31258C16.7196 9.13758 18.0934 9.38257 19.0821 10.0388C20.4646 10.9488 20.4646 12.4451 19.0909 13.3638Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.53534 7.29875C6.59659 7.29 6.65784 7.29 6.71909 7.29875C8.07534 7.255 9.15159 6.14375 9.15159 4.77875C9.15159 3.3875 8.02284 2.25 6.62284 2.25C5.23159 2.25 4.09409 3.37875 4.09409 4.77875C4.10284 6.14375 5.17909 7.255 6.53534 7.29875Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.63074 11.7452C6.63074 12.594 6.81449 13.399 7.14699 14.1252C5.91324 14.2565 4.62699 13.994 3.68199 13.3727C2.29949 12.454 2.29949 10.9577 3.68199 10.039C4.61824 9.40899 5.93949 9.15525 7.18199 9.29525C6.82324 10.0302 6.63074 10.8615 6.63074 11.7452Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5049 14.3862C11.4349 14.3775 11.3562 14.3775 11.2774 14.3862C9.66745 14.3337 8.3812 13.0125 8.3812 11.385C8.3812 9.7225 9.71995 8.375 11.3912 8.375C13.0537 8.375 14.4012 9.7225 14.4012 11.385C14.4012 13.0125 13.1237 14.3337 11.5049 14.3862Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66168 16.2C7.34043 17.0837 7.34043 18.5362 8.66168 19.4112C10.1667 20.4175 12.6341 20.4175 14.1391 19.4112C15.4604 18.5275 15.4604 17.075 14.1391 16.2C12.6429 15.1937 10.1754 15.1937 8.66168 16.2Z",
    fill: "#1D453F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(0.333344 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_191_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(0.333344 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors);
export default __webpack_public_path__ + "static/media/doctors.19e69ac19d4a3fef896620d250aa88c7.svg";
export { ForwardRef as ReactComponent };